import { LoadingOutlined } from "@ant-design/icons"
import {
	Form,
	Input,
	Modal,
	Select,
	Spin,
} from "antd"
import { useState, useEffect } from "react"
import { itSkillsSet, csSkillsSet, softSkillsSet } from "../Utils"

const AddEditSkillModalForm = ( {
	form,
	showMessage,
	editRecord,
	onCancel,
	onModalSubmit,
	rsSkillsGroup,
	analyzing,
	setAnalyzing,
} ) => {
	const [ isNew, setIsNew ] = useState( false )

	useEffect( () => {
		if (
			typeof editRecord === "object"
			&& editRecord !== null
			&& form.getFieldValue( "id" ) !== editRecord.id
		) {
			let initialData = JSON.parse( JSON.stringify( editRecord ) )
			initialData.itSkillsGroup = initialData.skillsGroup.filter( ( e ) => itSkillsSet.includes( e ) )
			initialData.csSkillsGroup = initialData.skillsGroup.filter( ( e ) => csSkillsSet.includes( e ) )
			initialData.sfSkillsGroup = initialData.skillsGroup.filter( ( e ) => softSkillsSet.includes( e ) )
			delete initialData.skillsGroup
			delete initialData.enabled
			form.setFieldsValue( initialData )
			setIsNew( false )
		} else if ( editRecord === "new" ) {
			setIsNew( true )
		}
	}, [ editRecord, form ] )

	return (
		<Modal
			getContainer={ false }
			centered
			open={ editRecord !== null }
			title={ isNew ? "Add a new skill" : "Edit skill" }
			width={ 850 }
			okText={ "Save" }
			cancelText={ "Cancel" }
			onCancel={ () => {
				if ( analyzing ) {
					showMessage( { type: "loading", content: "Analyzing Description...", key: "updatable", duration: 0.2 } )
					showMessage( { type: "warning", content: "Analysis stopped." } )
					setAnalyzing( false )
				}
				form.resetFields()
				onCancel()
			} }
			className={ isNew ? "add-skill-modal" : "edit-skill-modal" }
			onOk={ () => {
				form.validateFields().then( ( values ) => {
					if ( analyzing ) {
						showMessage( { type: "error", content: "Please wait for the analysis to finish." } )
						return
					}
					values.skillsGroup = values.itSkillsGroup.concat(
						values.csSkillsGroup,
						values.sfSkillsGroup,
					)
					delete values.itSkillsGroup
					delete values.csSkillsGroup
					delete values.sfSkillsGroup
					onModalSubmit( JSON.parse( JSON.stringify( values ) ), isNew )
					form.resetFields()
				} )
			} }
			okButtonProps={ { disabled: analyzing } }
			cancelButtonProps={ { disabled: analyzing } }
		>
			<Form
				preserve
				form={ form }
				layout={ "horizontal" }
				name={ isNew ? "add-skill-modal-form" : "edit-skill-modal-form" }
				labelCol={ { span: 7 } }
				wrapperCol={ { span: 15 } }
				labelWrap
				colon={ false }
				className={ "content-scroll" }
				initialValues={ {
					name: "My Skill",
					skillType: "manual",
					itSkillsGroup: [],
					csSkillsGroup: [],
					sfSkillsGroup: [],
				} }
			>
				<Form.Item
					name={ "name" }
					label={ "Title" }
					rules={ [
						{ required: true, message: "Please enter the title" },
						{ type: "string", min: 2, max: 1023 },
					] }
				>
					<Input />
				</Form.Item>

				<Form.Item name={ "itSkillsGroup" } label={ "IT Skills" } hidden={ analyzing }>
					<Select
						showSearch
						showArrow
						disabled={ analyzing }
						allowClear
						mode={ "multiple" }
						optionFilterProp={ "label" }
						options={ rsSkillsGroup
							.sort( ( a, b ) => ( a.name > b.name ? 1 : b.name > a.name ? -1 : 0 ) )
							.filter( ( e ) => itSkillsSet.includes( e.id ) )
							.map( ( skill ) => ( { value: skill.id, label: skill.name } ) ) }
					/>
				</Form.Item>

				<Form.Item name={ "csSkillsGroup" } label={ "CS Skills" } hidden={ analyzing }>
					<Select
						showSearch
						showArrow
						disabled={ analyzing }
						allowClear
						mode={ "multiple" }
						optionFilterProp={ "label" }
						options={ rsSkillsGroup
							.sort( ( a, b ) => ( a.name > b.name ? 1 : b.name > a.name ? -1 : 0 ) )
							.filter( ( e ) => csSkillsSet.includes( e.id ) )
							.map( ( skill ) => ( { value: skill.id, label: skill.name } ) ) }
					/>
				</Form.Item>

				<Form.Item name={ "sfSkillsGroup" } label={ "Soft Skills" } hidden={ analyzing }>
					<Select
						showSearch
						showArrow
						allowClear
						disabled={ analyzing }
						mode={ "multiple" }
						optionFilterProp={ "label" }
						options={ rsSkillsGroup
							.sort( ( a, b ) => ( a.name > b.name ? 1 : b.name > a.name ? -1 : 0 ) )
							.filter( ( e ) => softSkillsSet.includes( e.id ) )
							.map( ( skill ) => ( { value: skill.id, label: skill.name } ) ) }
					/>
				</Form.Item>

				<Form.Item name={ "skillType" } label={ "skillType" } hidden>
					<Input />
				</Form.Item>

				<Form.Item name={ "analysisSource" } label={ "analysisSource" } hidden>
					<Input />
				</Form.Item>

				<Form.Item name={ "id" } label={ "Id" } hidden>
					<Input />
				</Form.Item>

				{ analyzing && <div className={ "loading-icon-container" }>
					<Spin tip={ "Analysis in progress..." } indicator={ <LoadingOutlined style={ { fontSize: 24 } } spin /> } />
				</div> }
			</Form>
		</Modal>
	)
}

export default AddEditSkillModalForm
